import React from 'react'
import { Loader, Stack, Text } from '@mantine/core'

import { CourtReporterPageEvent } from './types'

import { CourtReporterWitnessEvent } from '@/apiClient'
import { Card } from '@/components/Event/Detail/components/Card'
import {
  DownloadAudioRecordingButton,
  DownloadVideoRecordingButton,
} from '@/components/Event/Detail/components/LinksCard'
import { useMediaResourcesQuery } from '@/queries/events'

export const RecordingsCard: React.FC<{ event: CourtReporterPageEvent }> = ({
  event,
}) => (
  <Card heading="Recordings">
    <Stack align="flex-start">
      <Text size="sm">
        If you need to access the recording, you can follow these links.
      </Text>

      <Recordings event={event} />

      {event.witness_events.map(witnessEvent => (
        <WitnessEventRecordings
          key={witnessEvent.id}
          witnessEvent={witnessEvent}
        />
      ))}
    </Stack>
  </Card>
)

const WitnessEventRecordings: React.FC<{
  witnessEvent: CourtReporterWitnessEvent
}> = ({ witnessEvent }) => (
  <Stack align="flex-start" spacing="xs">
    <Text size="sm" weight={600}>
      {witnessEvent.witness_name ?? 'Witness'}
    </Text>
    {witnessEvent.status === 'cancelled' ? (
      <Text size="sm" color="dimmed">
        The deposition of this witness was canceled, so there is no recording.
      </Text>
    ) : (
      <Recordings event={witnessEvent} />
    )}
  </Stack>
)

const Recordings: React.FC<{
  event: Pick<CourtReporterPageEvent, 'id' | 'media_resources_url'>
}> = ({ event }) => {
  const { data: media, isLoading } = useMediaResourcesQuery(event)

  if (isLoading) {
    return <Loader size="sm" />
  }

  return (
    <>
      <DownloadAudioRecordingButton media={media ?? []} />
      <DownloadVideoRecordingButton media={media ?? []} />
    </>
  )
}
